import React from "react";

interface TagProps {
  color?: "persian" | "green" | "red" | "yellow" | "blue";
  text: string;
}

const colorMaps = {
  persian: "bg-persian-100 text-persian-800 border border-persian-200",
  green: "bg-green-100 text-green-800 border border-green-200",
  red: "bg-red-100 text-red-800 border border-red-200",
  yellow: "bg-yellow-100 text-yellow-800 border border-yellow-200",
  blue: "bg-blue-100 text-blue-800 border border-blue-200",
};

export const Tag: React.FC<TagProps> = ({ color = "blue", text }) => {
  return (
    <span
      className={`
        px-1.5 py-px rounded-md text-sm font-medium inline-block
        ${colorMaps[color]}
      `}
    >
      {text}
    </span>
  );
};
